import React, { useMemo } from 'react';
import { Space } from 'antd';
import WidgetRender from './WidgetRender';

function DynamicForm(props: any) {
  const { widgets, parentKey, formName, index, selectedProducts, productLocked } = props;
  const preWidgets = Object.entries(widgets || {});

  return (
    <>
      <Space direction="vertical" style={{ width: '100%' }}>
        {preWidgets?.map((widget) => (
          <WidgetRender
            index={index}
            formName={formName}
            key={`${parentKey}-${formName}-${widget[0]}`}
            parentKey={parentKey}
            widgets={widget[1]}
            sectionHeader={widget[0]}
            selectedProducts={selectedProducts}
            productLocked={productLocked}
          />
        ))}
      </Space>
    </>
  );
}
export default DynamicForm;
